
import { useTranslation } from 'react-i18next';
import AdsInternal from './AdsInternal';
import {useConfig} from "../helpers/useConfig";
import { c_or_f } from '../helpers/Utils';
const ThisMonthClimate = ({desc, ThisMonth, lang, ads}) => {
    const { t } = useTranslation();
    const {configData, setConfig} = useConfig();
    let month_in_word = (lang == 0 ? desc.month_in_word0 : desc.month_in_word1); 
    let prevmonth_in_word = (lang == 0 ? desc.prevmonth_in_word0 : desc.prevmonth_in_word1); 
    const dayOfMonth = new Date().getDate();
    if (dayOfMonth <= 3) {month_in_word = prevmonth_in_word; }
    if (ThisMonth === undefined)
        return "loading...";
    return (
          <div id="thismonth_box_container" className={" " + (lang == 1? 'rtl' : '')}>
                    
                    <ul id="thismonth_box">
                             <li className="white_transp_box white_box">
                                <div className='d-grid'>
                                    <div> {month_in_word} </div>
                                    <div>{ThisMonth.dep >= 0 ?  t("WARMER_THAN_AVERAGE"): t("COLDER_THAN_AVERAGE")} </div>
                                    <div> {t("AT")}<span className="number">{Math.abs(ThisMonth.dep)}°</span> </div> 
                                </div>
                            </li>
                            <li className="white_transp_box white_box">
                                <div className='d-grid'>
                                    <div> {month_in_word} {t("AVERAGE")} </div> 
                                    <div> {t("MAX")}:<span className="number">{c_or_f(ThisMonth.hightemp_av, configData.tempUnit)}°</span> </div>
                                    <div>   {t("MIN")}:<span className="number">{c_or_f(ThisMonth.lowtemp_av, configData.tempUnit)}°</span> </div>
                                </div>
                            </li>
                           
                            <li className="white_transp_box white_box">
                                 <div className='d-grid'>
                                    <div>{month_in_word} {t("RECORDS")}</div>
                                    <div>{t("MAX")}:<span className="number">{c_or_f(ThisMonth.hightemp_ab, configData.tempUnit)}°</span> ({ThisMonth.hightemp_ab_date})</div>
                                    <div>{t("MIN")}:<div className="number">{c_or_f(ThisMonth.lowtemp_ab, configData.tempUnit)}°</div>  ({ThisMonth.lowtemp_ab_date})</div>
                                </div>
                            </li>
                           
                      </ul> 
                <div  title="" className="mx-auto parambox float">
                  
               
                </div>
               
                
                 
        </div>      
        
    );
}

export default ThisMonthClimate; 